import { type ComponentProps } from 'react';
import { Radio, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { FiberManualRecord } from '@material-ui/icons';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import classNames from 'classnames';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  radioUnchecked: customCheckboxRadioSwitch.radioUnchecked,
  radioChecked: customCheckboxRadioSwitch.radioChecked,
  radioCheckedDisabled: {
    borderColor: `${grayColor[0]} !important`,
    color: `${grayColor[0]} !important`,
  },
  radio: customCheckboxRadioSwitch.radio,
  radioDisabledChecked: {
    color: `${grayColor[0]} !important`,
  },
  radioRoot: customCheckboxRadioSwitch.radioRoot,
  label: extendedFormsStyle.label,
  labelDisabled: {
    cursor: 'not-allowed',
  },
  disabled: {
    cursor: 'not-allowed',
  },
});

type FormControlLabelProps = ComponentProps<typeof FormControlLabel>;

type LabeledRadioProps = {
  label: FormControlLabelProps['label'];
  FormControlLabelProps?: Partial<FormControlLabelProps>;
} & Partial<ComponentProps<typeof Radio>>;

const LabeledRadio = ({
  label,
  FormControlLabelProps: {
    classes: formControlLabelClasses,
    ...FormControlLabelProps
  } = {},
  ...radioProps
}: LabeledRadioProps) => {
  const classes = useStyles();

  const labelClassName = classNames(
    classes.label,
    radioProps.disabled && classes.labelDisabled
  );
  const radioCheckedClassName = classNames(
    classes.radio,
    radioProps.disabled && classes.radioDisabledChecked
  );
  const checkedIconClassName = classNames(
    classes.radioChecked,
    radioProps.disabled && classes.radioCheckedDisabled
  );

  return (
    <FormControlLabel
      classes={{
        label: labelClassName,
        disabled: classes.disabled,
        ...formControlLabelClasses,
      }}
      label={label}
      control={
        <Radio
          {...radioProps}
          icon={<FiberManualRecord className={classes.radioUnchecked} />}
          checkedIcon={<FiberManualRecord className={checkedIconClassName} />}
          classes={{
            checked: radioCheckedClassName,
            root: classes.radioRoot,
            ...radioProps.classes,
          }}
        />
      }
      {...FormControlLabelProps}
    />
  );
};

export default LabeledRadio;
